import {createContext} from 'react'
import {UserConfigStore} from './UserConfigStore';

export const storeContext = createContext({
    userConfigStore: new UserConfigStore
});
